var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1761708047977,
    className: "icon",
    viewBox: "0 0 1122 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10382,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 219.140625,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487.161 0L0 422.26l487.161 422.26V560.876S1161.815 342.135 1025.603 1024c0 0 435.88-828.495-547.256-771.606L487.161 0z",
    fill: "#8A8A8A",
    "p-id": 10383
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.bbefeebf5ca0e7138000fbac5648d80b.svg";
export { ForwardRef as ReactComponent };